var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwardSecond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37109 9.7V13.7609C4.37109 15.248 4.37109 15.248 5.77648 16.1958L9.64128 18.4265C10.2214 18.7615 11.1692 18.7615 11.7494 18.4265L15.6142 16.1958C17.0195 15.248 17.0195 15.248 17.0195 13.7609V9.7C17.0195 8.21291 17.0195 8.21291 15.6142 7.26509L11.7494 5.03446C11.1692 4.69945 10.2214 4.69945 9.64128 5.03446L5.77648 7.26509C4.37109 8.21291 4.37109 8.21291 4.37109 9.7Z",
    stroke: "#755421",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.191 6.92928V4.78035C15.191 3.14618 14.374 2.3291 12.7398 2.3291H8.65438C7.02021 2.3291 6.20312 3.14618 6.20312 4.78035V6.87208",
    stroke: "#755421",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.209 9.67467L11.6747 10.4019C11.7482 10.5163 11.9116 10.6307 12.0342 10.6633L12.8676 10.8758C13.3824 11.0065 13.5213 11.4477 13.1863 11.8563L12.6388 12.5181C12.5571 12.6243 12.4918 12.8123 12.4999 12.943L12.549 13.8009C12.5817 14.332 12.2058 14.6017 11.7155 14.4056L10.9148 14.0869C10.7922 14.0379 10.588 14.0379 10.4654 14.0869L9.66466 14.4056C9.17441 14.6017 8.79856 14.3239 8.83124 13.8009L8.88026 12.943C8.88844 12.8123 8.82307 12.6162 8.74136 12.5181L8.19391 11.8563C7.85891 11.4477 7.99781 11.0065 8.51258 10.8758L9.346 10.6633C9.47674 10.6307 9.64015 10.5081 9.70552 10.4019L10.1713 9.67467C10.4654 9.23344 10.923 9.23344 11.209 9.67467Z",
    stroke: "#755421",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardSecond);
export default __webpack_public_path__ + "static/media/award-second.dae1866d5c8a8fbd50d3d04f0ea86973.svg";
export { ForwardRef as ReactComponent };